
<template>
  <div>
    <v-dialog v-if="loading" persistent max-width="900px" transition="dialog-transition" >
      Carregando... 
      <v-progress-linear color='white' :indeterminate="true"></v-progress-linear>
    </v-dialog>

    <v-dialog v-model="dialog" persistent max-width="900px" transition="dialog-transition">
      <template v-slot:activator="{on}">
        <v-btn v-on="on" color="white black--text" class="ml-2" ><v-icon left>mdi-plus</v-icon>novo cheque</v-btn>
      </template>

      <v-card v-if="dialog" style="border-radius: 8px">
        <v-card-title primary-title>
          <div class="headline mb-0">Novo cheque retornado</div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-2">
          <template>
            <v-form ref='new_returned_form' lazy-validation>
              <v-row>
                <v-col cols='12' class="pa-0 mt-3">
                  <span class="font-weight-bold">Adicionando cheque retornado para:</span> 
                  <SelectModality :object_with_model="new_returned" class="mt-3 px-3" custom_label="Selecione o módulo para exibir os clientes" preselect_active/>
                </v-col>
              </v-row>

              <v-autocomplete 
                prepend-icon="mdi-account" 
                label="Cliente" 
                :items="all_clients" 
                :item-text="formatClientDisplayName" 
                item-value="id" 
                v-model="new_returned.client_id" 
                :rules="[rules.required]" 
                :filter="filterClients"
                :loading="loading_clients"
              >
                <template v-slot:selection="{item}">
                  <v-sheet width="100%" class="d-flex flex-column justify-start mt-2">
                    <span> {{ formatClientDisplayName(item) }} <span v-if="item.fantasyName">({{ item.fantasyName }})</span> </span>
                    <div class="d-flex justify-space-between mt-1 align-center">
                      <span class="caption">ID: {{item.id}}</span>
                      <span class="caption">Cidade: {{ item.city }} </span>
                    </div>
                  </v-sheet>
                </template>
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title class="pb-1"> Nome/Rz social: <b> {{ formatClientDisplayName(item) }} </b> </v-list-item-title>
                    <v-list-item-subtitle class="mb-1" v-if="item.fantasyName && item.fantasyName != item.name">Nome fantasia: <b> {{item.fantasyName}} </b></v-list-item-subtitle>
                    <v-list-item-subtitle class="d-flex justify-space-between">
                      <div>ID: <b>{{ item.id }} </b> </div>
                      <div>Cidade: <b>{{ item.city }}</b></div>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
              <v-text-field v-model="new_returned.number" prepend-icon="mdi-information" label="Número" v-mask="'######'" :rules="[rules.required, rules.ck_number]"></v-text-field>
              <v-text-field v-model="new_returned.motive" prepend-icon="mdi-information" label="Código do Motivo" :rules="[rules.motive]" v-mask="'##'"></v-text-field>
              <v-text-field v-model="new_returned.value_aux" v-currency="currency" prepend-icon="mdi-currency-brl" label="Valor" :rules="[rules.notZero]"></v-text-field>
              <v-textarea v-model="new_returned.comment" prepend-icon="mdi-message-reply" rows="3" label="Comentário"></v-textarea>
            </v-form>
          </template>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <f-btn cancel @click="close()"></f-btn>
          <f-btn save :disabled="loading_clients" @click="saveReturned()"></f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '@/api/index';
import {CurrencyDirective} from 'vue-currency-input'
import clientDisplay from '@/mixins/clientDisplay'

export default {
  name: "DialogNewReturned",
  mixins: [clientDisplay],
  directives: {currency: CurrencyDirective,},
  components: {
    SelectModality: () => import('@/components/shared/SelectModality.vue'),
  },
  data() {
    return {
      currency:{
        currency: null,
        locale: 'en-EN',
        autoDecimalMode: true,
        decimalLength: 2,
        distractionFree:false,
      },

      loading: false,
      loading_clients: false,

      all_clients: [],

      dialog: false,
      new_returned: {
        client_id: null,
        number: null,
        motive: null,
        value_aux: '0.00',
        comment: null,
        place_id: null
      },
      rules: {
        required: v => !!v || 'Campo é necessário',
        ck_number: v => !!v && v.length == 6 || 'Deve ter 6 dígitos. Ex: 000123',
        notZeroPercentage: v => (!!v && v != '0.00' && parseFloat(v) < 100) || 'Formato válido: "99.99"',
        notZero: v=> v != '0.00' || 'Não pode ser zero',
        motive: v => !!v && (v >= 10 && v <= 99) || 'Deve ser entre 10 e 99',
      },
      solution_map:{
        "wholesale": {text:"Grandes Cargas", color:"error"},
        "retail": {text:"Galpão", color:"primary"},
        "": {text:"Selecione a empresa", color:""},
      },
    }
  },
  methods: {
    getClients(){
      this.loading_clients = true
      this.new_returned.client_id = null
      Api.Client.index({ modality_id: this.new_returned.place_id, short: true }).then(r=>r.data).then(d=>{
        d = d.data? d.data.map(c=>c.attributes) : d
        this.all_clients = [...d]
        setTimeout(() => {
          this.loading_clients = false
        }, 1000);
      })
    },
    saveReturned(){
      if (this.$refs.new_returned_form.validate()){
        this.loading = true
        let {value_aux, ...r} = this.new_returned
        let obj = {
          ...r,
          value: value_aux.replace(/,/g, ''),
          returned_by: this.current_user_employee_name,
        }
        Api.ReturnedCheck.create(obj).then(r=>r.data).then(d=>{
          this.dialog = false
          this.$router.go()
        }).catch((err) => {
          console.log({err});
        }).finally(()=>{
          this.loading = false
        })
      }
    },
    filterClients (item, queryText, itemText) {
      const name = item.name ? item.name.toLowerCase() : ''
      const corporate_name = item.corporateName ? item.corporateName.toLowerCase() : ''
      const fantasyName = item.fantasyName ? item.fantasyName.toLowerCase() : ''
      const city = item.city ? item.city.toLowerCase() : ''
      const id = item.id ? item.id.toString() : ''
      const searchText = queryText.toLowerCase()

      return name.indexOf(searchText) > -1 || corporate_name.indexOf(searchText) > -1 || fantasyName.indexOf(searchText) > -1 || city.indexOf(searchText) > -1 || id.indexOf(searchText) > -1
    },
    close(){
      this.dialog = false
    },
    ...mapActions({
      indexClient: 'ClientFinancial/index',
    })
  },
  computed: {
    allClients_computed(){
      if (this.allClients){
        return this.allClients.map(obj=>obj.attributes)
      }
      return null
    },
    ...mapState({
      profile: state=>state.User.oneUser,
    })
  },
  mounted () {
    // this.getClients();
  },
  watch: {
    dialog(nv,ov) {
      if (nv == false){
        this.new_returned.client_id = null
        this.new_returned.number = null
        this.new_returned.motive = null
        this.new_returned.value_aux = '0.00'
        this.new_returned.comment = null
        this.new_returned.place_id = null
      }
    },
    'new_returned.place_id'(nv){
      if(nv){
        this.getClients();
      }
    }
  },
}
</script>

<style scoped>

</style>